import React from 'react';
import { Box, TextField, FormControlLabel, Switch } from '@mui/material';
import { WaField, optionalLabel } from '../whatsappPreview';
import { FlowComponent } from '../../../../flow-core/FlowComponent';
import { TextAreaCore } from '../../../../flow-core/components/TextAreaCore';

export const TextAreaComponent = new FlowComponent({
  ...TextAreaCore,
  renderPreview(properties) {
    return (
      <WaField
        typeable
        tall
        label={optionalLabel(properties.label || 'Enter text', properties.required)}
        helper={properties['helper-text']}
        properties={properties}
      />
    );
  },
  renderPropertyEditor(properties, onChange) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField
          fullWidth
          label="Field Name"
          value={properties.name || ''}
          onChange={(e) => onChange('name', e.target.value)}
          required
          size="small"
          helperText="Used to identify this field in the form data"
        />

        <TextField
          fullWidth
          label="Label"
          value={properties.label || ''}
          onChange={(e) => onChange('label', e.target.value)}
          required
          size="small"
        />

        <FormControlLabel
          control={
            <Switch
              checked={properties.required || false}
              onChange={(e) => onChange('required', e.target.checked)}
            />
          }
          label="Required"
        />

        <TextField
          fullWidth
          label="Helper Text"
          value={properties['helper-text'] || ''}
          onChange={(e) => onChange('helper-text', e.target.value)}
          size="small"
          helperText="Optional text shown below the text area"
        />
      </Box>
    );
  },
});
